import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';
import { SERVER } from '../config/config';
import {  FaEnvelope, FaInstagram, FaArrowRight } from 'react-icons/fa';
import { PiTiktokLogoLight } from "react-icons/pi";
import { LuFacebook } from "react-icons/lu";
import { GrLocation } from "react-icons/gr";

import { FiPhone } from "react-icons/fi";
import { MdOutlineMailOutline } from "react-icons/md";




const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when component mounts or location changes
    window.scrollTo(0, 0);
  }, [location]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      // Prepare data for backend (only send fields that backend expects)
      const contactData = {
        name: formData.name,
        email: formData.email,
        subject: formData.subject || 'Contact from Website',
        message: formData.message
      };

      const response = await axios.post(`${SERVER}/contact`, contactData);
      
      if (response.status === 201) {
        setSubmitMessage('Thank you! Your message has been sent successfully. We will get back to you soon.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          subject: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      setSubmitMessage('Sorry, there was an error sending your message. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const socialLinks = [
    { icon: <LuFacebook size={25}  />, url: 'https://www.facebook.com/p/WE-TEKUP-61570211227934/', color: 'text-blue-600' },
    { icon: <FaInstagram size={25} />, url: 'https://instagram.com/we.tekup', color: 'text-pink-600' },
    { icon: <PiTiktokLogoLight size={25}  />, url: 'https://www.tiktok.com/@we.tekup?lang=fr', color: 'text-blue-700' }
  ];

  return (
    <div>
      <Navbar />
      <div className="min-h-screen py-10">
        <div className="max-w-6xl mx-auto px-4">
          {/* Header */}
          <div className="mb-4 md:mb-16">
            <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">Contact</h1>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-16 lg:items-stretch">
            {/* Left Side - Contact Info Card */}
            <div 
              className="rounded-[40px] px-8 py-14 md:px-8 md:py-12 text-white relative overflow-hidden flex flex-col justify-between"
              style={{ backgroundColor: 'var(--primary-blue)' }}
            >
              {/* Find us Section */}
              <div className="mb-8 md:mb-6">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-4">Find us:</h2>
                <div className="space-y-3 md:space-y-3">
                  <div className="flex items-center gap-4">
                    <GrLocation   className="md:text-xl text-base flex-shrink-0" />
                    <span className="text-lg">Ain Zaghouan Sud</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <FiPhone  className="md:text-xl text-base flex-shrink-0" />
                    <span className="text-lg">+216 28 655 323</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <MdOutlineMailOutline  className="md:text-xl text-base flex-shrink-0" />
                    <span className="text-lg">wetekup@gmail.com</span>
                  </div>
                </div>
              </div>

              {/* Follow us Section */}
              <div>
                <h2 className="text-xl text-base md:text-2xl font-bold mb-4 md:mb-4">Follow us:</h2>
                <div className="flex gap-4">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 border-2 border-white rounded-full flex items-center justify-center text-white hover:bg-white hover:text-blue-600 transition-all duration-300"
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="space-y-8 flex flex-col justify-between">
              {submitMessage && (
                <div className={`p-4 rounded-lg ${
                  submitMessage.includes('Thank you') 
                    ? 'bg-green-50 text-green-800 border border-green-200' 
                    : 'bg-red-50 text-red-800 border border-red-200'
                }`}>
                  {submitMessage}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-3 md:space-y-3 flex-1 flex flex-col">
                <div className="flex-1 space-y-3 md:space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Your name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200"
                      placeholder="Your full name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email address
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200"
                      placeholder="Your email address"
                    />
                  </div>

                  <div className="flex-1 flex flex-col">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Message
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="w-full flex-1 px-4 py-3 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 resize-none"
                      placeholder="Write something..."
                      style={{ minHeight: '120px' }}
                    />
                  </div>
                </div>
                
                <div className='w-full flex justify-end mt-4'>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="inline-flex items-center gap-3 px-6 md:px-4 py-3 md:py-3 text-white font-medium rounded-full shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{ backgroundColor: 'var(--primary-blue)' }}
                  >
                    <span>{isSubmitting ? 'Sending...' : 'Send message'}</span>
                    <FaArrowRight className="w-6 h-6 bg-white rounded-full text-black p-1.5 md:p-1" strokeWidth="0.5" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;